package com.hyperether.goodjob.scenes.dashboard


import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material.Divider
import androidx.compose.material.Text
import androidx.compose.material3.DrawerState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.navigation.NavHostController
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.Sp
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.log
import com.hyperether.goodjob.models.Job
import com.hyperether.goodjob.navigation.AddNew
import com.hyperether.goodjob.navigation.Map
import com.hyperether.goodjob.navigation.Register
import com.hyperether.goodjob.navigation.safeNavigate
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.check_soon
import com.hyperether.goodjob.resources.dashboard
import com.hyperether.goodjob.resources.error
import com.hyperether.goodjob.resources.error_employee_number
import com.hyperether.goodjob.resources.error_manager_number
import com.hyperether.goodjob.resources.job
import com.hyperether.goodjob.resources.jobs
import com.hyperether.goodjob.resources.jobs_overview
import com.hyperether.goodjob.resources.no_tasks_assigned
import com.hyperether.goodjob.resources.no_tasks_created
import com.hyperether.goodjob.resources.today_schedule
import com.hyperether.goodjob.resources.total
import com.hyperether.goodjob.scenes.components.ErrorDialog
import com.hyperether.goodjob.scenes.components.ErrorDialogWeb
import com.hyperether.goodjob.scenes.components.FilterButton
import com.hyperether.goodjob.scenes.components.MobileHeaderSearchAdd
import com.hyperether.goodjob.scenes.jobs.components.FilterJobsDialog
import com.hyperether.goodjob.scenes.jobs.components.JobsList
import com.hyperether.goodjob.scenes.map.MapViewModel
import com.hyperether.goodjob.scenes.scheduler.SchedulerJobWeeklyPopUpDetailed
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.util.FilterDialogStateManager
import com.hyperether.goodjob.util.JobStatusMap
import com.hyperether.planner.ui.DashboardDayPlanner
import com.hyperether.planner.ui.SchedulerDayPlanner
import com.hyperether.resources.stringResource

@Composable
fun DashboardScreen(
    isMobileView: Boolean,
    navHostController: NavHostController,
    dashboardViewModel: DashboardViewModel,
    mapViewModel: MapViewModel,
    drawerState: DrawerState,
    screenWidth: Float = 0f,
    screenHeight: Float = 0f,
) {
    val tabHeight = Dp(40f)
    val mobileHeaderSearchAddHeight = Dp(60f)
    val bottomNavigationHeight = Dp(56f) // BottomNavigationHeight

    dashboardViewModel.jobStatusMap = JobStatusMap()
    val contacts by dashboardViewModel.allContactsMap.collectAsStateWithLifecycle()
    val jobSearchText = remember { mutableStateOf("") }

    LaunchedEffect(isMobileView) {
        if (isMobileView) {
            dashboardViewModel.loadRemoteData()
        }
    }
    LaunchedEffect(Unit) {
        FilterDialogStateManager.setDialogShowing(false)
        dashboardViewModel.jobClicked.value = false
        dashboardViewModel.navigateToRegister.collect {
            navHostController.navigate(Register)
        }
    }
    // TODO move to view model
    LaunchedEffect(dashboardViewModel.filteredJobs.toList()) {
        dashboardViewModel.parseSchedule()
        val events = dashboardViewModel.listOfPlans.flatMap { it.events }
        log.d("Scheduler DashboardScreen parseSchedule") { "events size: ${events.size}" }
    }

    // TODO move to view model
    val isJobsOverviewSelected = remember { mutableStateOf(true) }
    val selectedJobs = remember { mutableStateListOf<Job>() }

    if (isMobileView) {
        Column {
            MobileHeaderSearchAdd(
                title = stringResource(Res.string.dashboard),
                drawerState = drawerState,
                scope = rememberCoroutineScope(),
                add = { navHostController.navigate(AddNew) },
                search = {
                    navHostController.safeNavigate(Map)
                },
                searchOnMap = true,
                user = mapViewModel.getUser()
            )

            Column(
                modifier = Modifier
                    .background(Color.LightGray.copy(alpha = 0.2f))
                    .padding(Dp(8f)),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth().height(tabHeight),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Box(
                        modifier = Modifier
                            .weight(0.5f)
                            .fillMaxSize()
                            .clickable(
                                interactionSource = remember { MutableInteractionSource() },
                                indication = null
                            ) {
                                isJobsOverviewSelected.value = false
                            },
                        contentAlignment = Alignment.Center
                    ) {
                        androidx.compose.material3.Text(
                            text = stringResource(Res.string.today_schedule),
                            color = if (isJobsOverviewSelected.value) Color.Gray else BlueApp,
                            fontSize = Sp(16f),
                            textAlign = TextAlign.Center,
                        )
                    }

                    Box(
                        modifier = Modifier
                            .weight(0.5f)
                            .fillMaxSize()
                            .clickable(
                                interactionSource = remember { MutableInteractionSource() },
                                indication = null
                            ) {
                                isJobsOverviewSelected.value = true
                            },
                        contentAlignment = Alignment.Center
                    ) {
                        androidx.compose.material3.Text(
                            text = stringResource(Res.string.jobs_overview),
                            color = if (isJobsOverviewSelected.value) BlueApp else Color.Gray,
                            fontSize = Sp(16f),
                            textAlign = TextAlign.Center,
                        )
                    }
                }
            }
            Box(
                modifier = Modifier
                    .height(Dp(2f))
                    .fillMaxWidth(0.5f)
                    .background(if (isJobsOverviewSelected.value) BlueApp else BlueApp)
                    .align(if (isJobsOverviewSelected.value) Alignment.End else Alignment.Start)
            )
            if (dashboardViewModel.isEmployee() && dashboardViewModel.jobList.size == 0) {
                androidx.compose.material3.Text(
                    text = stringResource(Res.string.no_tasks_created),
                    color = Color.Black,
                    fontSize = Sp(24f),
                    textAlign = TextAlign.Center,
                    fontWeight = FontWeight.Bold,
                    modifier = Modifier.fillMaxWidth()
                        .padding(top = Dp(60f), start = Dp(16f), end = Dp(16f))
                )
                androidx.compose.material3.Text(
                    text = stringResource(Res.string.check_soon),
                    color = Color.Gray,
                    textAlign = TextAlign.Center,
                    fontSize = Sp(16f),
                    modifier = Modifier.padding(top = Dp(20f), start = Dp(16f), end = Dp(16f))
                )
            } else if (!dashboardViewModel.isEmployee() && dashboardViewModel.jobList.size == 0) {
                androidx.compose.material3.Text(
                    text = stringResource(Res.string.no_tasks_created),
                    color = Color.Black,
                    fontSize = Sp(24f),
                    textAlign = TextAlign.Center,
                    fontWeight = FontWeight.Bold,
                    modifier = Modifier.fillMaxWidth()
                        .padding(top = Dp(60f), start = Dp(16f), end = Dp(16f))
                )
                androidx.compose.material3.Text(
                    text = stringResource(Res.string.no_tasks_assigned),
                    color = Color.Gray,
                    textAlign = TextAlign.Center,
                    fontSize = Sp(16f),
                    modifier = Modifier.padding(top = Dp(20f), start = Dp(16f), end = Dp(16f))
                )
            } else {
                if (isJobsOverviewSelected.value) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = Dp(16f), vertical = Dp(16f)),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        val leadingText =
                            if (dashboardViewModel.filteredJobs.size == 1) stringResource(Res.string.job) else stringResource(
                                Res.string.jobs
                            )
                        Text(
                            text = stringResource(Res.string.total) + ": ${dashboardViewModel.filteredJobs.size} $leadingText",
                            fontSize = Sp(14f),
                            color = Color.Gray,
                            modifier = Modifier.weight(1f),
                            textAlign = TextAlign.Start
                        )
                        FilterButton()
                    }
                    Divider(
                        modifier = Modifier.height(Dp(1f))
                            .background(Color.LightGray.copy(alpha = 0.1f))
                    )
                    JobsList(
                        sites = dashboardViewModel.sitesMap,
                        jobs = dashboardViewModel.searchAndSortJobs(jobSearchText.value),
                        selectedJobs = selectedJobs,
                        isInEditMode = false,
                        navHostController = navHostController
                    )
                } else {
//                    Row(
//                        modifier = Modifier.fillMaxWidth(),
//                        verticalAlignment = Alignment.CenterVertically,
//                        horizontalArrangement = Arrangement.Center
//                    ) {
//                        IconButton(onClick = {}) {
//                            Icon(
//                                painter = painterResource(Res.drawable.chevron_left),
//                                contentDescription = "Left Icon"
//                            )
//                        }
//                        Text(
//                            text = stringResource(Res.string.today),
//                            modifier = Modifier.padding(horizontal = Dp(8f)),
//                            textAlign = TextAlign.Center,
//                            style = TextStyle(fontSize = Sp(16f), color = Color.DarkGray)
//                        )
//                        IconButton(onClick = {}) {
//                            Icon(
//                                painter = painterResource(Res.drawable.chevron_right),
//                                contentDescription = "Right Icon"
//                            )
//                        }
                    //                   }
                    if (!dashboardViewModel.isEmployee()) {
                        SchedulerDayPlanner(
                            listOfPlans = dashboardViewModel.listOfPlans,
                            startHour = dashboardViewModel.listOfPlans.flatMap { it.events }
                                .minOfOrNull { it.from.hour } ?: 8,
                            onEventClicked = { event ->
                                val selectedJob =
                                    dashboardViewModel.jobList.firstOrNull { it.id == event.jobId }
                                dashboardViewModel.selectedJobDashboard.value = selectedJob
                                selectedJob?.let { dashboardViewModel.updateSite(it) }
                                dashboardViewModel.jobClicked.value = true
                            },
                            isMobile = isMobileView,
                            screenHeight = if (screenHeight > 0) screenHeight - tabHeight.value - mobileHeaderSearchAddHeight.value - bottomNavigationHeight.value else screenHeight,
                            screenWidth = screenWidth
                        )
                    } else {
                        DashboardDayPlanner(
                            onEventClicked = { event ->
                                val selectedJob =
                                    dashboardViewModel.jobList.firstOrNull { it.id == event.jobId }
                                dashboardViewModel.selectedJobDashboard.value = selectedJob
                                selectedJob?.let { dashboardViewModel.updateSite(it) }
                                dashboardViewModel.jobClicked.value = true
                            },
                            listOfPlans = dashboardViewModel.listOfPlans,
                            screenHeight = if (screenHeight > 0) screenHeight - tabHeight.value - mobileHeaderSearchAddHeight.value - bottomNavigationHeight.value else screenHeight,
                            screenWidth = screenWidth,
                            isMobileView = isMobileView,
                            startHour = dashboardViewModel.listOfPlans.flatMap { it.events }
                                .minOfOrNull { it.from.hour } ?: 8)
                        //SchedulerDayPlanner(listOfPlans = planList.toMutableList())
                    }
                }
            }
        }
    } else {
        SelectionContainer {
            DashboardScreenWeb(
                mapViewModel = mapViewModel,
                dashboardViewModel = dashboardViewModel,
                selectedJobs = selectedJobs,
                isInEditMode = false,
                navHostController = navHostController,
                screenWidth = screenWidth,
                screenHeight = screenHeight,
                isMobileView = isMobileView
            )
        }
    }

    val userTeams = mapViewModel.getUser()?.teams
    if (FilterDialogStateManager.dialogShowing.value) {
        FilterJobsDialog(
            dashboardViewModel.getFilterMap(),
            onDismiss = { FilterDialogStateManager.setDialogShowing(false) },
            onApply = { map ->
                FilterDialogStateManager.setDialogShowing(false)
                dashboardViewModel.applyFilter(map)
                dashboardViewModel.filterJobs()
                dashboardViewModel.parseSchedule()
            },
            isMobileView = isMobileView,
            isEmployee = dashboardViewModel.isEmployee(),
            userTeams = userTeams
        )
    }

    if (dashboardViewModel.isManagerNumberExceeded.value) {
        if (getPlatformChecker().isMobile()) {
            ErrorDialog(
                onDismiss = { dashboardViewModel.isManagerNumberExceeded.value = false },
                title = stringResource(Res.string.error).uppercase(),
                message = stringResource(Res.string.error_manager_number)
            )
        } else {
            ErrorDialogWeb(
                onDismiss = { dashboardViewModel.isManagerNumberExceeded.value = false },
                title = stringResource(Res.string.error).uppercase(),
                message = stringResource(Res.string.error_manager_number)
            )
        }
    }
    if (dashboardViewModel.isEmployeeNumberExceeded.value) {
        if (getPlatformChecker().isMobile()) {
            ErrorDialog(
                onDismiss = { dashboardViewModel.isEmployeeNumberExceeded.value = false },
                title = stringResource(Res.string.error).uppercase(),
                message = stringResource(Res.string.error_employee_number)
            )
        } else {
            ErrorDialogWeb(
                onDismiss = { dashboardViewModel.isEmployeeNumberExceeded.value = false },
                title = stringResource(Res.string.error).uppercase(),
                message = stringResource(Res.string.error_employee_number)
            )
        }
    }
    if (dashboardViewModel.jobClicked.value) {
        dashboardViewModel.selectedJobDashboard.value?.let {
            SchedulerJobWeeklyPopUpDetailed(
                dashboardViewModel.jobSites,
                contacts[it.id],
                job = it,
                onDismissRequest = {
                    dashboardViewModel.jobClicked.value = false
                }
            )
        }
    }
}